interface ErrorPageProps {
  message?: string;
}

export default function ErrorPage({
  message = 'Something went wrong.',
}: ErrorPageProps) {
  return (
    <main className="system-page">
      <div className="system-page__inner">
        <p className="system-page__code">Error</p>
        <h1>Unable to Load</h1>
        <p>{message}</p>
        <a href="/">Return to home</a>
      </div>
    </main>
  );
}
